<template>
  <div
    class="uep_player"
    id="uep_player_component"
    v-bind:class="{ isNotRadyPlayer: !isRadyPlayer , 'is-tmp' : options && options.paramsOptions && options.paramsOptions.isTmp }"
  >


    <mail-call-to-action
      v-if="player && !options.initialized && !options.passwordOptions && options.playerOptions && options.interactivityOptions && options.interactivityOptions.data && options.interactivityOptions.data.cta && options.interactivityOptions.data.cta.selected == 'form' "
      :email-options="information.sendMailOptions"
      :player="player"></mail-call-to-action>
    <div class="background_play_list"></div>
    <div class="debug" v-if="options.debug">
      <span v-html="debug" v-if="options.debug"></span>
    </div>


    <div class="active-muted"
         v-if="isRadyPlayer && muted &&  showActivateSound && options.playerOptions.autoplay && options.playerOptions.sources[0].type !== 'video/youtube'"
         v-on:click="activateSound">
      Activer le son

      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           width="25px"
           viewBox="0 0 31.237 31.237" style="enable-background:new 0 0 31.237 31.237;" xml:space="preserve">

	<g id="c75_volume">
		<path style="fill:#fff;" d="M4.363,10.761H0v9.715h4.363l8.244,6.114c0,0,1.512,1.268,1.512-0.041c0-1.312,0-20.858,0-22.051
			c0-1.028-1.33-0.024-1.33-0.024L4.363,10.761z"/>
    <path style="fill:#fff;" d="M18.816,8.865c-0.436-0.434-1.137-0.434-1.568,0c-0.436,0.434-0.436,1.138,0,1.568
			c1.426,1.431,2.133,3.286,2.135,5.157c-0.002,1.875-0.709,3.742-2.135,5.166c-0.436,0.434-0.436,1.136,0,1.573
			c0.215,0.218,0.498,0.324,0.785,0.324c0.281,0,0.566-0.106,0.783-0.324c1.855-1.859,2.787-4.306,2.785-6.739
			C21.604,13.155,20.672,10.721,18.816,8.865z"/>
    <path style="fill:#fff;" d="M21.824,5.37c-0.438-0.436-1.139-0.436-1.572,0c-0.43,0.435-0.43,1.137,0,1.572
			c2.398,2.396,3.592,5.52,3.596,8.657c-0.004,3.154-1.193,6.292-3.596,8.702c-0.432,0.434-0.43,1.133,0,1.57
			c0.219,0.212,0.502,0.322,0.787,0.322c0.283,0,0.568-0.11,0.785-0.322c2.832-2.84,4.242-6.562,4.242-10.272
			C26.066,11.901,24.645,8.194,21.824,5.37z"/>
    <path style="fill:#fff;" d="M25.508,1.79c-0.432-0.436-1.135-0.436-1.57,0c-0.43,0.434-0.43,1.138,0,1.568
			c3.387,3.387,5.078,7.809,5.078,12.245c0,4.449-1.686,8.884-5.078,12.278c-0.434,0.433-0.43,1.139,0,1.57
			c0.219,0.215,0.504,0.322,0.789,0.322c0.281,0,0.564-0.107,0.781-0.322c3.822-3.825,5.73-8.845,5.729-13.849
			C31.238,10.607,29.32,5.602,25.508,1.79z"/>
	</g>

</svg>


    </div>

    <video-player
      v-if="!options.initialized && !options.passwordOptions && options.playerOptions"
      id="name_player"
      :isBo="options.paramsOptions && options.paramsOptions.isBO"
      class=""
      ref="videoPlayer"
      :relatedVideosOptions="options.relatedVideosOptions"
      :statsOptions="options.statsOptions"
      :options="options.playerOptions"
      :videoId="Number(videoId)"
      :information="information"
      :infoOptions="options.infoOptions"
      :isChapters="options.rmOptions && (options.rmOptions.chapters ? options.rmOptions.chapters.length > 0 : options.rmOptions.chapters)"
      :is360="options.panoramaOptions"
      mediaType="video"
      @ready="onPlayerReadied"
      :hasVideoStats="hasVideoStats"
    >
    </video-player>
    <div v-if="options.initialized && !options.passwordOptions" class="loader"></div>
    <password-component :options="options" v-if="options.passwordOptions"></password-component>
    <annotation-display
      v-if="annotationsOptions.init && player != null"
      :options="annotationsOptions"
    ></annotation-display>
    <hidden-area-display
      v-if="hiddenAreasOptions && hiddenAreasOptions.length > 0 && player != null"
      :options="hiddenAreasOptions"
      :player="player"
    ></hidden-area-display>
    <uep-player-statics
      v-if="!options.initialized && player !== null"
      :options="options"
      :player="player"
    ></uep-player-statics>

    <div id="playlist-uep" class="vjs-playlist"></div>

  </div>
</template>

<script>
  import {HTTP, HTTP_STAT} from '../core/http/http-common';
  import Routing from '../core/router/router';
  import * as API from '../core/api/utilsClient';
  import helper from '../mixins/helper';
  import VideoPlayer from './VideoPlayer.vue';
  import MailCallToAction from "./MailCallToAction.vue";

  //import vuenut from '../components/vueNavigationComponents/vuenut.vue'
  export default {
    name: 'uep-player',
    mixins: [helper],
    components: {
      VideoPlayer,
      MailCallToAction,
      VideoInformation: () => import("./VideoInformation.vue"),
      HiddenAreaDisplay: () => import("./HiddenAreaDisplay.vue"),
      UepPlayerStatics: () => import("../components/UepPlayerStatics.vue"),
      AnnotationDisplay: () => import("../components/AnnotationDisplay.vue"),
      PasswordComponent: () => import("./passwordComponent.vue"),
    },
    props: {
      options: {
        type: Object,
        required: true
      },
      videoId:null,
      hasVideoStats:false
    },
    data() {
      return {
        showActivateSound: true,
        initialized: true,
        isRadyPlayer: false,
        currentSkin: ['skin-16'],
        items: null,
        player: null,
        background: null,
        isFullScreenLandscape: false,
        annotationsOptions: {
          init: false
        },
        showModalStatic: false,
        hiddenAreasOptions: [],
        debug: "init player<br>",
        information: {}
      }
    },
    computed: {
      muted() {
        return this.options.playerOptions.muted
      },
      hiddenAreasReady() {
        return this.hiddenAreasOptions.length > 0 &&
          this.player != null &&
          this.options.plugin === 'interactivity' &&
          this.options.currentSkin.indexOf('skin-i2') > -1;
      },
      isDarkSkin() {
        console.log(this.options)
        console.log(this.options.currentSkin[0])
        console.log(this.player)
        /**todo test */
        return true;
      },
      isSkin18() {
        console.log(this.options);
        return (
          this.options &&
          this.options.currentSkin &&
          this.options.currentSkin[0] === 'skin-18'  &&
          this.player
        );
      },
    },
    created: function () {
      this.$nextTick(function () {
        // Code that will run only after the
        // entire view has been re-rendered
      })
      this.debug += "<br>line 65 : created";
      //window.addEventListener('beforeunload', this.addLastResponseBeforeUnload)
      let self = this;
      eventHub.$on('showActivateSound', function () {
        console.log("showActivateSound")
        self.showActivateSound = false
      });
    },
    mounted() {
      this.$nextTick(function () {
        //Init
        //this.handleResize()
      });
      this.debug += "<br>line 73 : mounted";
      var self = this;
      eventHub.$on('authentication', function () {
        self.$nextTick(function () {
          self.options.passwordOptions = false;
        })
      });


    },
    methods: {
      initPlayer360() {
        console.log(this.options.panoramaOptions)
        this.debug += "<br>---- initPlayer360 -----" + this.options.panoramaOptions;

        try {
          if (this.options.panoramaOptions) {
          console.log(this.options.panoramaOptions)
            var self = this;
            import ('videojs-panorama/dist/videojs-panorama.min.css');
            import('videojs-panorama').then(function (e) {
              self.player.panorama({
                clickAndDrag: true,
                clickToToggle: true,
                autoMobileOrientation: true,
                Notice: {
                  Enable: true,
                  Message: "Pour découvrir le panorama, faites glisser votre souris (ou votre doigt si vous êtes sur mobile) dans la video."
                },
              });
            });

          }
        } catch (e) {
          console.log("initPlayer360");
          console.log(e);
        }
      },
      initContextMenuUI() {
        var self = this;
        this.debug += "<br>line 86 : contextmenuUI";
        import('videojs-contextmenu/dist/videojs-contextmenu.js').then(function (e) {
          import('videojs-contextmenu-ui/dist/videojs-contextmenu-ui.js').then(function (e) {
            self.player.contextmenuUI({
              content: [{
                label: 'UEP v 2.0.1'
              }, {
                // A link with a listener. Its `href` will automatically be `#`.
                href: "http://www.empreinte.com",
                label: 'Powered by Empreinte.com'
              }, {
                // A link with a listener. Its `href` will automatically be `#`.
                label: 'Statistiques',
                listener: function () {
                  self.showModalStatic = true;
                  eventHub.$emit('showModalStatic');
                }
              }]
            });
          });
        });
      },
      importCTA() {
        this.debug += "<br>line 104 : initCTA";
        var self = this;
        try {
          if (this.options.interactivityOptions && this.options.interactivityOptions.data && this.options.interactivityOptions.data.cta) {
            import('videojs-cta/dist/videojs-cta.cjs').then(function (e) {
              self.player.cta(self.options.interactivityOptions.data.cta);
            });
            import ('videojs-cta/dist/videojs-cta.css');
          }
        } catch (e) {
          console.log("initCTA");
          console.log(e);
        }
      },
      addLastResponseBeforeUnload() {
        this.debug += "<br>line 119 : addLastResponseBeforeUnload";
        var self = this;
        var params = {
          eventId: 3,
          serviceParam: {
            p1: self.player.currentTime(),
            event_object: "video_unload"
          }
        };

        self.sendStatsData(params);
      },
      initReloadSourceOnError() {
        this.debug += '<br>line 131 : initReloadSourceOnError';
        var reloadOptions = {};
        var self = this;
        var uepPlayer = this.player;
        var src = this.options.playerOptions.sources[0];
        reloadOptions.errorInterval = 1000;
        reloadOptions.getSource = function (reload) {
          // call reload() with a fresh source object
          // you can do this step asynchronously if you want (but the error dialog will
          // show up while you're waiting)
          reload({
            src: '',
            type: 'application/x-mpegURL',
          });
        };
        this.player.reloadSourceOnError(reloadOptions);
        eventHub.$emit('error', {code: 'test', cause: 'test'});
        this.player.on('error', function (event) {
          self.isRadyPlayer = true;
          var code, dialog, params, cause;
          code = event.target && event.target.error ? event.target.error.code : event.code;
          cause = event.cause ? event.cause : 'Flux de lecture introuvable';
          params = {
            cause: cause,
            exception: code,
            module: 'player',
            error_code: code,
          };
          HTTP.post(Routing.generate('api_log', params)).then(
            function (response) {
              console.log(response);
            },
            function (error) {
              console.log(error);
            },
          );
          uepPlayer.addClass('vjs-error-uep');
          // create the dialog
          dialog = document.createElement('div');
          dialog.className = 'vjs-error-dialog';
          dialog.innerHTML = `<div id="alert-box" class="alert-box" style="display: block;">
              <div class="title-box">Flux de lecture introuvable</div>
              <div class="content-box">
                  <div class="line" id ='uep_error' style="cursor: pointer;">Erreur de flux, cliquez ici pour réessayer</div>
              </div>
          </div>`;
          uepPlayer.el().appendChild(dialog);
          // add it to the DOM
        });
        document.addEventListener('click', function (e) {
          if (e.target && e.target.id == 'uep_error') {
            errorUep();
          }
        });

        function errorUep() {
          uepPlayer.src(src);
        }
      },
      initStylePlayer() {
        this.debug += '<br>line 193 : initStylePlayer';
        if (this.options.currentSkin.length > 0) {
          for (var x in this.options.currentSkin) {
            this.player.addClass(this.options.currentSkin[x]);
            if (this.options.currentSkin[x] === "skin-overlay") {
              this.initOverlaySkin()
            }
          }
        }

        if (this.options.menu === "default")
          this.player.addClass("skin-default");
        //setup_control_bar_top(this.player);
        this.player.height(window.innerHeight);
      },
      initOverlaySkin() {
        var controlsBars = document.querySelector(".vjs-control-bar")
        if (controlsBars) {
          let controlsChilds = controlsBars.children;
          if (controlsChilds.length > 0) {
            for (let i = 0; i < controlsChilds.length; i++) {
              controlsChilds[i].classList.add("vjs-hide-options")
              if (controlsChilds[i].classList.contains("vjs-play-control") ||
                controlsChilds[i].classList.contains("vjs-volume-panel") ||
                controlsChilds[i].classList.contains("vjs-fullscreen-control") ||
                controlsChilds[i].classList.contains("vjs-progress-control")
              ) {
                controlsChilds[i].classList.remove("vjs-hide-options")
                if (controlsChilds[i].classList.contains("vjs-play-control")) {
                  var arriowLeft = "<i class='icon-arrow-left  vjs-control vjs-button'></i>"
                  var arriowRight = "<i class='icon-arrow-left right  vjs-control vjs-button'></i>"
                  var playBtn = document.querySelector(".vjs-play-control")
                  var parent = playBtn.parentNode;
                  var parentPlayBtn = document.createElement('div');
                  parentPlayBtn.classList = "play-buttons";
                  parent.replaceChild(parentPlayBtn, playBtn);
                  parentPlayBtn.innerHTML = `${arriowLeft}${arriowRight}`
                  parentPlayBtn.appendChild(playBtn);
                }
              }

            }
          }
        }
      },
      initVrOptions() {
       /* if (this.options.vrOptions && this.options.vrOptions.projection !== "0") {
          if (!this.player.mediainfo) {
            this.player.mediainfo = {};
          }
          if (!this.player.mediainfo.projection) {
            this.player.mediainfo.projection = '360';
          }
          this.player.vr(this.options.vrOptions);
        }*/
      },
      initRichMedia() {
        this.debug += "<br>line 214 : initRichMedia";
        var self = this;
        try {
          if (this.options.plugin !== "fixedNavigation" &&
            this.options.rmOptions &&
            ((this.options.rmOptions.hasOwnProperty('chapters') && this.options.rmOptions.chapters.length > 0) ||
              (this.options.rmOptions.hasOwnProperty('slides') && this.options.rmOptions.slides.length))) {
            this.options.rmOptions.isDarkSkin = !!this.isDarkSkin;
            import('videojs-rich-media/dist/videojs-rich-media.min').then(function (e) {
              self.player.richMedia(self.options.rmOptions);
            });
          }
        } catch (e) {
          console.log('initRichMedia');
          console.log(e);
        }
      },
      iniInteractivity() {
        if (this.options.interactivityOptions && this.options.plugin === "interactivity") {
          var self = this;
          this.debug += "<br>line 227 : iniInteractivity";
          try {
            this.player.getChild('controlBar').getChild('VolumePanel').volumeControl.vertical = false;
            this.player.getChild('controlBar').getChild('VolumePanel').volumeControl.volumeBar.vertical(false);
          } catch (e) {
            console.log('version 5 ');
            if (this.player.getChild('controlBar').getChild('volumeMenuButton'))
              this.player.getChild('controlBar').getChild('volumeMenuButton').volumeBar.vertical(false)
          }
          this.options.allOptions = {};
          var api = {
            HTTP: HTTP,
            URL: Routing.generate('api_media_post_add_rich_media_responses'),
            client: this.options.client
          };
          var apiFileDownload = {
            HTTP: HTTP,
            URL: Routing.generate('api_media_get_player_attached_file_by_id'),
          };
          this.options.allOptions.api = api;
          this.options.allOptions.apiFileDownload = apiFileDownload;
          this.options.allOptions.currentSkin = this.options.currentSkin;
          this.options.allOptions.markers = this.options.interactivityOptions ? (this.options.interactivityOptions.data ? this.options.interactivityOptions.data.interactivity.filter(function (e) {
            return e.type !== 'chapter'
          }) : {}) : {}
          this.player.skinControlBar({
            ...this.options.allOptions,
            isTmp: this.options.paramsOptions && this.options.paramsOptions.isTmp,
          });
        }
      },
      initStats() {
        var ressourceHttp = HTTP_STAT;

        if (this.options.paramsOptions && this.options.paramsOptions.isBO === true) {
          this.options.statsOptions = false;
        }
        if (this.options.statsOptions) {
          this.debug += "<br>line 266 : initStats";
          var self = this;
          this.options.statsOptions.client = this.options.client;
          this.options.statsOptions.autoplay=this.options.playerOptions.autoplay
          import('videojs-stat-tracking/dist/videojs-stat-tracking.cjs').then(function (e) {
            self.player.statTracking(self.options.statsOptions, ressourceHttp);
          });
        }
      },
      initHotKey() {
        var self = this;
        import ('videojs-modal-hot-key/dist/videojs-modal-hot-key.css');
        import('videojs-hotkeys/videojs.hotkeys').then(function (e) {
          self.player.hotkeys({
            volumeStep: 0.1,
            seekStep: 2,
            enableMute: true,
            enableFullscreen: true,
            enableNumbers: false,
            enableVolumeScroll: true,
            // Enhance existing simple hotkey with a complex hotkey
            fullscreenKey: function (e) {
              // fullscreen with the F key or Ctrl+Enter
              return e.ctrlKey && (e.which === 70 || e.which === 13);
            },
            rewindKey: function (e, player) {
              if (e.shiftKey && e.which === 37) {
                var wasPlaying = !player.paused();
                if (wasPlaying) {
                  player.pause();
                }
                var current = player.currentTime();
                var seekTime = current - 10;
                // The flash player tech will allow you to seek into negative
                // numbers and break the seekbar, so try to prevent that.
                if (seekTime >= 0) {
                  player.currentTime(seekTime);
                }
                if (wasPlaying) {
                  player.play();
                }
              } else if (e.which === 37) {
                return true
              }
            },
            forwardKey: function (e, player) {
              if (e.shiftKey && e.which === 39) {
                var duration = player.duration();
                var wasPlaying = !player.paused();
                if (wasPlaying) {
                  player.pause();
                }
                var current = player.currentTime();
                var seekTime = current + 10;
                // The flash player tech will allow you to seek into negative
                // numbers and break the seekbar, so try to prevent that.
                if (seekTime <= duration) {
                  player.currentTime(seekTime);
                }
                if (wasPlaying) {
                  player.play();
                }
              } else if (e.which === 39) {
                return true
              }
            },
            // Custom Keys
            customKeys: {
              // Add new simple hotkey
              simpleKey: {
                key: function (e) {
                  // Toggle something with o Key
                  return (e.which === 79);
                },
                handler: function (player, options, e) {
                  if (window._defaultMenuComponent) {
                    let dom = videojs.dom || videojs;
                    dom.toggleClass(window._defaultMenuComponent.el_, "hot-key-show");
                  }
                  docShadow.querySelector('.skin-dark .vjs-settings-menu-content') &&
                  docShadow
                    .querySelector('.skin-dark .vjs-settings-menu-content')
                    .classList.toggle('vjs-hidden');
                }
              },
              // Add new complex hotkey
              complexKey: {
                key: function (e) {
                  // Toggle something with CTRL + D Key
                  return (e.ctrlKey && e.which === 68);
                },
                handler: function (player, options, event) {
                  // Example
                  if (options.enableMute) {
                    player.muted(!player.muted());
                  }
                }
              },
              // Override number keys example from https://github.com/ctd1500/videojs-hotkeys/pull/36
              numbersKey: {
                key: function (event) {
                  // Override number keys
                  return ((event.which > 47 && event.which < 59) || (event.which > 95 && event.which < 106));
                },
                handler: function (player, options, event) {
                  // Do not handle if enableModifiersForNumbers set to false and keys are Ctrl, Cmd or Alt
                  if (options.enableModifiersForNumbers || !(event.metaKey || event.ctrlKey || event.altKey)) {
                    var sub = 48;
                    if (event.which > 95) {
                      sub = 96;
                    }
                    var number = event.which - sub;
                    player.currentTime(player.duration() * number * 0.1);
                  }
                }
              },
              ExportKey: {
                key: function (e) {
                  return (e.which === 69);
                },
                handler: function (player, options, event) {
                  player.getChild('ExportOverlay').open();
                }
              },
              mailKey: {
                key: function (e) {
                  return (e.which === 66);
                },
                handler: function (player, options, event) {
                  player.getChild('SendMailOverlay').open();
                }
              },
              infoKey: {
                key: function (e) {
                  return (e.which === 73);
                },
                handler: function (player, options, event) {
                  player.getChild('InfoOverlay').open();
                }
              },
              playPauseKey: {
                key: function (e) {
                  return e.which === 32;
                },
                handler: function (player, options, event) {
                  if (player.paused()) {
                    player.play();
                  } else {
                    player.pause();
                  }
                },
              },
              emptyHotkey: {
                // Empty
              },
              withoutKey: {
                handler: function (player, options, event) {
                }
              },
              withoutHandler: {
                key: function (e) {
                  return true;
                }
              },
              malformedKey: {
                key: function () {
                },
                handler: function (player, options, event) {
                  //Empty
                }
              }
            }
          });
          if (self.options.hotKeyOptions && self.options.plugin !== "montage") {
            self.debug += "<br>line 419 : initHotKey";

            import('videojs-modal-hot-key/dist/videojs-modal-hot-key.cjs').then(function (e) {
              self.player.modalHotKey({});
            });

          }
        });
      },
      initSendMail() {
        if (!this.options.uid) {
          try {
            if (this.options.plugin !== "simple" && this.options.plugin !== "montage" && this.options.sendMailOptions) {
              var self = this;
              self.options.sendMailOptions = {
                HTTP: HTTP,
                URL: Routing.generate('api_media_send_video_by_mail_from_player'),
                cryptedParam: self.options.crypttext,
                client: self.options.client
              };

              this.debug += "<br>line 426 : initSendMail";
              import('videojs-mail/dist/videojs-mail.cjs').then(function (e) {
                self.player.sendMail(self.options.sendMailOptions);
              });
              import ('videojs-mail/dist/videojs-mail.css');
            }
          } catch (e) {
            console.log('initSendMail');
            console.log(e);
          }
        }
      },
      initShareSocialMedia() {
        if (!this.options.uid) {
          try {
            if (this.options.plugin !== "montage" && this.options.shareOptions) {
              this.debug += "<br>line 438 : initShareSocialMedia";

              var self = this;
              import ('videojs-share-social-media/dist/videojs-share-social-media.css');
              import('videojs-share-social-media/dist/videojs-share-social-media.cjs').then(function (e) {
                self.player.shareSocialMedia(self.options.shareOptions);
                eventHub.$emit('partageButton', self.player.getChild("ShareSocialMedia").el());
              });


            }
          } catch (e) {
            console.log('initShareSocialMedia');
            console.log(e);
          }
        }
        /**/
      },
      initShowInfo() {
       /* try {
          if (this.options.plugin !== "montage" && this.options.infoOptions) {
            var self = this;
            this.debug += "<br>line 451 : initShowInfo";
            import ('videojs-info/dist/videojs-info.css');
            import('videojs-info/dist/videojs-info.cjs').then(function (e) {
              self.getStatsVideo({
                list_videos: "[" + self.options.playerOptions.videoId + "]",
                client: self.options.client
              });
            });


          }
        } catch (e) {
          console.log('initShowInfo');
          console.log(e);
        }*/
      },
      importExportShare() {
        if (!this.options.uid) {
          var self = this;
          if (this.options.exportOptions && this.options.exportOptions.length > 0) {
            import ('videojs-export-share/dist/videojs-export-share.css');
            import('videojs-export-share/dist/videojs-export-share.cjs').then(function (e) {
              self.player.exportShare(self.options.exportOptions);
            });


          }
        }
        /* */
      },

      initDownloadVideo() {
        var self = this;
        if (this.options.plugin !== "montage" && this.options.downloadOptions) {
          this.debug += "<br>line 475 : initDownloadVideo";
          import ('videojs-download-video/dist/videojs-download-video.css');
          import('videojs-download-video/dist/videojs-download-video.cjs').then(function (e) {
            self.player.downloadVideo(self.options.downloadOptions);
          });
        }
      },
      initVarNavigation() {

        var self = this;
        self.options.allOptions = {};
        self.options.allOptions.menuOptions = ['close'];
        if (((self.options.exportOptions && self.options.exportOptions.hasOwnProperty('url')) || (self.options.shareOptions && self.options.shareOptions.hasOwnProperty('socials')))) {
          self.options.allOptions.menuOptions.push('share');
        }
        if (self.options.files && self.options.files.length > 0) {
          self.options.allOptions.filesOptions = {};
          self.options.allOptions.filesOptions.files = self.options.files;
          self.options.allOptions.menuOptions.push('files');
        }
        if (self.options.sendMailOptions) {
          self.options.sendMailOptions = {
            HTTP: HTTP,
            URL: Routing.generate('api_media_send_video_by_mail_from_player'),
            cryptedParam: self.options.crypttext,
            client: self.options.client
          };
          self.options.allOptions.sendMailOptions = self.options.sendMailOptions;
        }
        if (self.options.surveyOptions) {
          var api_post_survey = {
            HTTP: HTTP,
            URL: Routing.generate('api_survey_add_response_to_survey_for_video'),
            videoId: self.options.playerOptions.videoId,
            client: self.options.client
          };
          //waiting the api
          var api_list_survey = {
            HTTP: HTTP,
            URL: Routing.generate('api_media_get_survey_for_video', {id: self.options.playerOptions.videoId}),
            client: self.options.client
          };
          self.options.allOptions.menuOptions.push('survey');
          self.options.allOptions.surveyOptions = {};
          self.options.allOptions.surveyOptions.api = {
            api_list_survey: api_list_survey,
            api_post_survey: api_post_survey
          };
        }
        if (self.options.commentsOptions) {
          var api_post_comment = {
            HTTP: HTTP,
            URL: Routing.generate('api_media_post_add_comments'),
            mediaId: self.options.playerOptions.mediaId,
            client: self.options.client
          };
          var api_list_comment = {
            HTTP: HTTP,
            URL: Routing.generate('api_media_get_comment_media_by_video', {id: self.options.playerOptions.videoId}),
            client: self.options.client
          };
          self.options.allOptions.menuOptions.push('comments');
          self.options.allOptions.commentsOptions = {};
          self.options.allOptions.commentsOptions.noScroll = true;
          self.options.allOptions.commentsOptions.api = {
            api_list_comment: api_list_comment,
            api_post_comment: api_post_comment
          };
        }
        if (self.options.searchOptions) {

          var api_search = {
            HTTP: HTTP,
            URL: Routing.generate('api_media_get_interactivities'),
            client: self.options.client,
            videoId: self.options.playerOptions.videoId
          };
          var api_search_post = {
            HTTP: HTTP,
            URL: Routing.generate('api_media_post_add_rich_media_responses'),
            client: self.options.client,
            videoId: self.options.playerOptions.videoId
          };
          self.options.allOptions.searchOptions = {};
          self.options.allOptions.searchOptions.api = {
            api_search: api_search,
            api_search_post: api_search_post
          };
          self.options.allOptions.menuOptions.push('search');
        }
        if (self.options.infoOptions && self.options.infoOptions.hasOwnProperty('title')) {
          self.options.allOptions.menuOptions.push('info');
        }
        self.options.allOptions.exportOptions = self.options.exportOptions;
        self.options.allOptions.infoOptions = self.options.infoOptions;
        self.options.allOptions.rmOptions = self.options.rmOptions;
        self.options.allOptions.shareOptions = self.options.shareOptions;
        if (self.options.rmOptions && self.options.rmOptions.hasOwnProperty('chapters') && self.options.rmOptions.chapters.length > 0) {
          self.options.allOptions.menuOptions.push('richMedia');
        }
        if (self.options.allOptions.menuOptions.length == 1) {
          self.options.navigation = false;
        }
      },
      initNavigation() {
        try {
          if (this.options.navigation) {
            var self = this;
            this.debug += "<br>line 482 : initNavigation";
            //this.player.search();
            if (this.options.allOptions.commentsOptions) {
              import('videojs-comments/dist/videojs-comments.cjs').then(function (e) {
                self.player.comments(self.options.allOptions.commentsOptions);
              });
              import ('videojs-comments/dist/videojs-comments.css');
            }

            /* if (this.options.allOptions.surveyOptions) {
               import('videojs-survey/dist/videojs-survey.cjs').then(function (e) {
                 self.player.survey(self.options.allOptions.surveyOptions);
               });
               import ('videojs-survey/dist/videojs-survey.css');
             }
             if (this.options.allOptions.searchOptions) {
               import('videojs-search/dist/videojs-search.cjs').then(function (e) {
                 self.player.search(self.options.allOptions.searchOptions);
               });
               import ("videojs-search/dist/videojs-search.css");
             }*/

            this.options.allOptions.isDarkSkin = !!this.isDarkSkin;

            this.player.navigation(this.options.allOptions);

          }
        } catch (e) {
          console.log('initNavigation');
          console.log(e);
        }
      },
      importNavigation() {
        /* var self = this;
         if (this.options.navigation) {
           import ('videojs-navigation/dist/videojs-navigation.css');
           import('videojs-navigation/dist/videojs-navigation.cjs').then(function (e) {
             if (self.options.allOptions.filesOptions) {
               import('videojs-files/dist/videojs-files.cjs').then(function (e) {
                 self.initNavigation();
               })
               import ('videojs-files/dist/videojs-files.css');
             } else {
               self.initNavigation();
             }

           });
         }*/
      },
      initMenuSetting() {
        try {
          if (this.options.menu === "default" && !(this.options.currentSkin.indexOf("skin-generator") > -1)) {
            var self = this;
            this.debug += "<br>line 506 : initMenuSetting";
            var options = this.options.hlsQualityOptions;
            if (options) {
              options.menu = this.options.menu ? this.options.menu : null;
              try {
                this.player.hlsQuality(options);
              } catch (e) {
                console.log("hlsQuality", e)
              }
              options = {};
              //'languageMenu',
              options.entries = [];
              if (this.options.infoOptions) {
                options.entries = ['informationMenu'];
                options.info = this.options.infoOptions;
              }
              if (videojs.browser && videojs.browser.TOUCH_ENABLED === true || this.options.playerOptions.playbackRates === "") {
                if (this.isDarkSkin) {
                  options.entries = options.entries.concat(['aboutMenu', 'qualitySelector', 'helpMenu']);
                  options.isDarkSkin = true;
                } else {
                  options.entries = options.entries.concat(['helpMenu', 'qualitySelector', 'aboutMenu']);
                }
              } else if (this.isDarkSkin) {
                options.entries = options.entries.filter(i => i !== 'informationMenu');
                options.entries = options.entries.concat(['aboutMenu', 'qualitySelector', 'playbackRateMenuButton', 'helpMenu']);
                options.isDarkSkin = true;
              } else {
                options.entries = options.entries.concat(['helpMenu', 'qualitySelector', 'playbackRateMenuButton', 'aboutMenu']);
              }
              import('videojs-settings-menu/dist/videojs-settings-menu.js').then(function (e) {
                self.player.defaultSkin(options);
              });
              import ('videojs-settings-menu/dist/videojs-settings-menu.css');

            }
          }
        } catch (e) {
          console.log('initMenuSetting');
          console.log(e);
        }

      },

      initLanguage() {
        var self = this;
        import('videojs-setting-language/dist/videojs-setting-language.cjs').then(function (e) {
          self.player.settingLanguage(self.options.playerOptions.language);

          self.player.on('changeLanguage', function (event, lang) {
            eventHub.$emit('changeLanguage', lang);
            self.options.playerOptions.language = lang;
            self.player.trigger('loadstart');
          })
        });
        import ('videojs-setting-language/dist/videojs-setting-language.css');
      },
      initCallExtern() {
        var uepPlayer = this.player;
        let hasApiParams=this.$route.query.api &&  this.$route.query.api !=="undefined" ? true : false
        if ((this.options.communicationOptions && this.options.communicationOptions === "1") ||
            hasApiParams  ) {
            setup_call_extern(this.player);
          this.player.on('timeupdate', function () {
            API.moveToNextChapSld(uepPlayer)
          })
        }
      },
      updateDisplayCC() {


        var newSettings = {
          backgroundOpacity: '0.5',
          edgeStyle: 'none',
          fontFamily: 'proportionalSansSerif',
          backgroundColor: 'black',
          fontPercent: '0.50'
        };

        this.player.textTrackSettings.setDefaults();
        this.player.textTrackSettings.setValues(newSettings);
        this.player.textTrackSettings.updateDisplay();

      },
      initEventListner() {
        var self = this;
        var uepPlayer = this.player;
        // can also be `tap` or `touchend` or some other event instead of `click`
        this.debug += "<br>line 574 : initEventListner";
        this.player.on('touchend', function (e) {
          self.debug += "<br>line 576 : initEventListner touchend";
          if (e.target == docShadow.querySelector(".video-js.vjs-has-started .vjs-tech")) {
            if (self.player.paused()) {
              self.player.play();
            } else {
              self.player.pause();
            }
          }
        });

        // volume
        this.player.on('volumechange', function (e) {
          self.debug += "<br>line 588 : initEventListner volumechange";
          self.$cookie.set('uep-player-volume', self.player.volume())
          if (!self.player.muted()) {
            self.showActivateSound = false
          }
        })
        //disabled click playback rate
        self.debug += "<br>line 592 : initEventListner volumechange";
        if (docShadow.querySelector('button.vjs-playback-rate.vjs-menu-button.vjs-menu-button-popup.vjs-button') && videojs.getComponent('PlaybackRateMenuButton'))
          this.player.off(docShadow.querySelector('button.vjs-playback-rate.vjs-menu-button.vjs-menu-button-popup.vjs-button'), 'click', videojs.getComponent('PlaybackRateMenuButton').prototype.handleClick);

        /****/
        try {
          if (videojs.browser && videojs.browser.TOUCH_ENABLED === true) {
            self.debug += "<br>line 599 : initEventListner TOUCH_ENABLED";
            window.screen.orientation.addEventListener("change", function (e) {
              self.debug += "<br>line 601 : initEventListner change";
              if (!self.player.isFullscreen()) {
                if (screen.orientation.type.indexOf('landscape') >= 0) {
                  self.player.requestFullscreen();
                  self.isFullScreenLandscape = true;
                } else {
                  self.player.exitFullscreen();
                }
              } else {
                if (screen.orientation.type.indexOf('landscape') < 0) {
                  if (self.isFullScreenLandscape) {
                    self.isFullScreenLandscape = false;
                    self.player.exitFullscreen();
                  }
                }
              }
            }, false);
          }
        } catch (e) {
          self.debug += "<br>line 621 : initEventListner TOUCH_ENABLED";
        }


        this.player.on('fullscreenchange', function () {

          self.debug += "<br>line 627 : initEventListner fullscreenchange";

          if (videojs.browser && videojs.browser.TOUCH_ENABLED === true && uepPlayer.isFullscreen() && screen.orientation.type.indexOf('landscape') < 0) {
            window.screen.orientation.lock('landscape-primary');
          }
        });

        self.debug += "<br>line 634 : initEventListner fullscreenchange";
      },
      initAnnotation() {
        var self = this;
        self.annotationsOptions.annotations = this.options.interactivityOptions && this.options.interactivityOptions.data && this.options.interactivityOptions.data.annotations ? this.options.interactivityOptions.data.annotations : false;
        if (self.annotationsOptions.annotations) {
          self.annotationsOptions.player = this.player;
          self.annotationsOptions.init = true;
        }
      },
      initHiddenArea() {
        var self = this;
        if (this.options && this.options.interactivityOptions && this.options.interactivityOptions.data && this.options.interactivityOptions.data.interactivity) {
          self.hiddenAreasOptions = this.options.interactivityOptions.data.interactivity.filter(i => i.type === "hidden-area");
        }
      },
      initDarkTheme() {
        if (!this.isDarkSkin) {
          return;
        }
        this.information = {
          primary: this.options.infoOptions || {},
          share: this.options.shareOptions || {},
          exportOptions: this.options.exportOptions || {},
          files: this.options.files || [],
          sendMailOptions: this.options.sendMailOptions,
          chapters: this.options.rmOptions ? this.options.rmOptions.chapters : [],
          client:this.options.client
        };
        this.addBigPauseButton();
      },
      initSkin18Theme() {
        if (!this.isSkin18) {
          return;
        }
        this.information = {
          primary: this.options.infoOptions || {},
          share: this.options.shareOptions || {},
          exportOptions: this.options.exportOptions || {},
          files: this.options.files || [],
          sendMailOptions: this.options.sendMailOptions,
          chapters: this.options.rmOptions ? this.options.rmOptions.chapters : [],
        };
        this.addBigPauseButton();
      },
      addBigPauseButton() {
        var bigBtnEl = docShadow.querySelector('.vjs-big-play-button');
        if (bigBtnEl) {
          bigBtnEl.addEventListener('touchend', (e) => {
            if (this.player.hasClass('vjs-playing') && !this.player.paused()) {
              this.player.pause();
            }
          });
        }
      },
      chromelessVideo() {
        if (!this.options.playerOptions.controlBarOptions) {
          import ('../assets/css/skin/control-bar-hide.css');
          this.hideControlBar(this.player);
          this.player.volume(0.6);
        }
      },
      activateSound() {
        //muted
        this.showActivateSound = false;
        eventHub.$emit('SetMuted')
        // this.options.playerOptions.muted = false;
      },
      initParams() {
        var self = this;
        if (this.options.plugin === "navigation") {
          self.initVarNavigation();
        } else if (this.options.plugin === "interactivity") {
          self.options.allOptions = {};
          self.options.allOptions.infoOptions = self.options.infoOptions;
          self.options.allOptions.menuOptions = ['info'];
          if (self.options.rmOptions && self.options.rmOptions.hasOwnProperty('slides') && self.options.rmOptions.slides.length > 0) {
            self.options.rmOptions.hideSliders = true;
          }
        }
      },
      initPlugin() {
        var self = this;
        self.initParams();
        this.initHotKey();
        this.initShareSocialMedia();

        this.importExportShare();
        this.initDownloadVideo();
        this.initMenuSetting();

        this.importNavigation();
        this.initLanguage();
        this.initAnnotation();
        this.initHiddenArea();

        this.initContextMenuUI();
        //this.initVrOptions();
        this.initEventListner();
        if (this.options.paramsOptions && this.options.paramsOptions.isBO === false) {
          this.player.on('ended', function () {
            var params = {
              eventId: 3,
              serviceParam: {
                p1: null,
                event_object: "video_ended"
              }
            };
            self.sendStatsData(params);
          });
        }
        this.initialized = true;
        (this.options.playerOptions.textTracks || []).forEach(this.player.addRemoteTextTrack.bind(this.player));


      },
      onPlayerReadied() {
        var self = this;

        try {
          var defaultVolume = this.$cookie.get('uep-player-volume') ? this.$cookie.get('uep-player-volume') : 0.6;
          var fixedInfo = false;
          /* display player's poster */
          this.showPlayerPoster(this.options);
          this.initSendMail();
          this.importCTA();
          this.player = this.$refs.videoPlayer.player;
          self.player = this.player;
          this.player.volume(defaultVolume);
          if (!this.options.initialized) {
            this.initDarkTheme();
            this.initCallExtern();
            this.initSkin18Theme();
            this.iniInteractivity();
            this.initShowInfo();
             this.initStats();
              this.initPlayer360();
            console.log("initialized")
            console.log(this.options)
            eventHub.$emit('readyPlayer', this.player);
            eventHub.$off('switchplaylistitem');
            if (videojs.browser && videojs.browser.TOUCH_ENABLED === true) {
              self.isRadyPlayer = true;
              self.initPlugin();
            } else {
              //
              self.debug += "<br>line 692 : init------------------------------";
              if (this.options.playerOptions.autoplay) {
                self.isRadyPlayer = true;
                self.initPlugin();

              } else {
                self.isRadyPlayer = true;
                this.player.one('canplay', function () {
                  setTimeout(function () {
                    self.initPlugin();
                  },200)

                });
              }

            }

            if (this.options.hlsQualityOptions && this.options.plugin !== "montage") {

              this.player.on('loadedmetadata', function () {
                setTimeout(function (e) {
                  var options = self.options.hlsQualityOptions;
                  options.menu = self.options.menu ? self.options.menu : null;
                  try {
                    self.player.hlsQuality(options);
                  } catch (e) {
                    console.log("hlsQuality", e)
                  }
                }, 500)
              });
            }
            this.debug += "<br>line 652 : onPlayerReadied";
            this.debug += "<br>line 684 : onPlayerReadied " + this.options.debugText;
            this.debug += "<br>line 685 : playerOptions" + JSON.stringify(this.options.playerOptions);
            this.initStylePlayer();
            this.chromelessVideo();
            this.updateDisplayCC();
              eventHub.$on('displayCC',(opt)=>{
                if(opt.value){
                    this.updateDisplayCC();
                    if(opt.textTracks.length > 0){
                      let ccBtn=document.querySelector('.vjs-control-bar .vjs-captions-button.vjs-menu-button.vjs-button ')
                      if(ccBtn){
                        if(ccBtn.classList.contains('vjs-hidden')){
                          ccBtn.classList.remove('vjs-hidden')
                        }
                      }
                        (opt.textTracks || []).forEach(this.player.addRemoteTextTrack.bind(this.player));
                    }else{
                      let ccBtn=document.querySelector('.vjs-control-bar .vjs-captions-button.vjs-menu-button.vjs-button ')
                      if(ccBtn){
                        if(!ccBtn.classList.contains('vjs-hidden')){
                          ccBtn.classList.add('vjs-hidden')
                        }
                      }
                    }
                }
            })

            //this.initReloadSourceOnError();

            try {
              if (this.options && this.options.paramsOptions && this.options.paramsOptions.startTime)
                this.player.currentTime(this.options.paramsOptions.startTime)
            } catch (e) {
            }


            //this.player.playlist({ videos: videosList, playlist: { hideSidebar: false, upNext: true, hideIcons: false, thumbnailSize: 300, items: 3 } });
//          this.player.modalHotKey({});


            var player = this.player;
            if (this.options.playListOptions && this.options.playListOptions.hasOwnProperty('sources') && this.options.playListOptions.sources.length > 0) {
              let current_video = this.options.playListOptions.indexVideo ? this.options.playListOptions.indexVideo : this.options.playListOptions.sources.findIndex(video => video.selected === true);
              player.currentPlaylistIndex = current_video;
              this.player.on('ended', function (e) {
                docShadow.querySelector('#uep_player_component').classList.add('is_playlist');
                docShadow.querySelector('.background_play_list').style.backgroundImage = 'url(' + self.background + ')';
                docShadow.querySelector('.background_play_list').style.height = '100%';
                current_video = current_video + 1;
                if (self.options.playListOptions.sources[current_video])
                  eventHub.$emit('nextVideo', current_video);
                else if (self.options.playListOptions.loop) {
                  current_video = 0;
                  eventHub.$emit('nextVideo', current_video);
                }
              });

              this.player.one('timeupdate', function (e) {
                self.background = self.options.playerOptions.poster;
                docShadow.querySelector('#uep_player_component').style.backgroundImage = "";
                docShadow.querySelector('.background_play_list').style.backgroundImage = '';
                docShadow.querySelector('.background_play_list').style.height = '0%';
              });
              import ('videojs-playlist-uep/dist/videojs-playlist-uep.css')
              if (this.options.playerOptions.controlBarOptions) {
                this.player.addClass('vjs-playlist-on');
                docShadow.getElementById('playlist-uep').classList.add('vjs-playlist-show');
              }
              //this.player.playlist(this.options.playListOptions.sources);


              let skinOverlay = this.options.currentSkin.find(skin => skin === "skin-overlay");
              let playlistObject = {
                sources: this.options.playListOptions.sources,
                loop: this.options.playListOptions.loop,
                controlBarOptions: this.options.playerOptions.controlBarOptions
              }
              if (skinOverlay) {
                playlistObject = Object.assign({}, playlistObject, {skin: skinOverlay})
                var playlistUep = document.getElementById('playlist-uep')
                if (playlistUep) {
                  playlistUep.classList.add('vjs-hide-playlist-el');
                }
              }
              this.player.playlistUep(playlistObject);
              // this.player.playlist.autoadvance(0);
              if (this.options.playerOptions.autoplay === true)
                this.player.play();
              if (this.options.playListOptions.loop)
                this.player.playlistUEP.repeat(true);
              // this.player.playlistUep(docShadow.getElementById('playlist-uep'));
            }
          }
        } catch (err) {
          self.debug += "<br>line 794 : catch all";
          console.log(err);
        }
      },
      getStatsVideo(data) {
        let self = this;
        let nb_view = 0;
        HTTP.get(Routing.generate("api_media_get_number_visits", data))
          .then(function (response) {
            console.log(response);
            nb_view = response.data && response.data.data && response.data.data[0] && response.data.data[0].number_visits ? response.data.data[0].number_visits : 0;
            self.options.infoOptions.nb_views = nb_view;
            if (self.isDarkSkin) {
              self.information.primary = self.options.infoOptions || {};
            }

            self.player.info(self.options.infoOptions);
            eventHub.$emit('infoDetails', self.options.infoOptions)
          }, function (error) {
            console.log(error);
          });
      },
      SendLevelError() {
        var qualityList = this.player.qualityLevels();
        setTimeout(function () {
          console.log('playerrrrr ', self.player);
          var qualityList = self.player.qualityLevels();
          const levels = qualityList.levels_;
          var heights = [];
          for (let i = 0; i < levels.length; ++i) {
            heights.push(levels[i].height);
          }
          var code, params;
          code = "This player has a problem with quality list";
          params = {
            cause: heights.toString() + ' id_video ' + self.player.options_.videoId,
            exception: code,
            module: 'player',
            error_code: code,
            client: self.options.client,
          };
          HTTP.post(Routing.generate('api_log', params)).then(
            function (response) {
            },
            function (error) {
              console.log(error);
            },
          );
        }, 9000);
      },
    },
    watch: {
      options: {
        deep: true,
        handler: function (options, oldOptions) {

          this.options = options;
          this.initDarkTheme();
          this.initCallExtern();
          this.initSkin18Theme();
           this.initStats();
          if(!!!oldOptions.rmOptions )
            this.initRichMedia();
        },


      },
    }

  };

  function setup_call_extern(player) {
    var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message';
    eventer(
      messageEvent,
      function (e) {
        if (e.data.fn == 'getEndedVideo') {
          API.getEndedVideo(player);
        } else if (e.data.fn == 'getCurrentTime') {
          window.parent.postMessage(API.getCurrentTime(player), '*');
        } else if (e.data.fn == 'launch_pause') {
          window.parent.postMessage(API.launch_pause(player), '*');
        } else if (e.data.fn == 'launch_only_play') {
          window.parent.postMessage(API.launch_only_play(player), '*');
        } else if (e.data.fn == 'launch_only_pause') {
          window.parent.postMessage(API.launch_only_pause(player), '*');
        } else if (e.data.fn == 'synchronize_inverse') {
          API.synchronize_inverse(player, e.data.params.join());
        }else if (e.data.method ==='play') {
              window.parent.postMessage(API.launch_only_play(player), '*');
        }
      },
      false,
    );
  }
</script>

<style>
  .isNotRadyPlayer:not(.vjs-tech-html5) button.vjs-big-play-button { /* :not(.vjs-tech-html5) is an exception for flash on IE*/
    display: none !important;
  }

  .isNotRadyPlayer .vjs-live button.vjs-big-play-button {
    display: block !important;
  }

  .isNotRadyPlayer .vjs-poster {
    display: none !important;
  }

  /*loader*/
  .loader {
    color: #ababab;
    text-indent: -9999em;
    overflow: hidden;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    position: relative;
    top: 40%;
    transform: translate(-50%, -50%);
    animation: load 1.7s infinite ease, round 1.7s infinite ease;
  }

  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 600px) {
    .loader {
      left: 45%;
      font-size: 35px;
    }
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    .loader {
      left: 47%;
      font-size: 35px;
    }
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    .loader {
      left: 47%;
      font-size: 40px;
    }
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    .loader {
      left: 48%;
      font-size: 40px;
    }
  }

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    .loader {
      left: 48%;
      font-size: 60px;
    }
  }

  @keyframes load {
    0% {
      box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em,
      0 -0.83em 0 -0.477em;
    }
    5%,
    95% {
      box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em,
      0 -0.83em 0 -0.477em;
    }
    10%,
    59% {
      box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em, -0.173em -0.812em 0 -0.44em,
      -0.256em -0.789em 0 -0.46em, -0.297em -0.775em 0 -0.477em;
    }
    20% {
      box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em, -0.555em -0.617em 0 -0.44em,
      -0.671em -0.488em 0 -0.46em, -0.749em -0.34em 0 -0.477em;
    }
    38% {
      box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em, -0.645em -0.522em 0 -0.44em,
      -0.775em -0.297em 0 -0.46em, -0.82em -0.09em 0 -0.477em;
    }
    100% {
      box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em,
      0 -0.83em 0 -0.477em;
    }
  }

  @keyframes round {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .is-tmp .video-js.vjs-skin-control-bar.skin-i2 .vjs-progress-control, .is-tmp .video-js.vjs-skin-control-bar.skin-i2.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-progress-control {
    display: block;
    height: 8px;
    top: -8px !important;
  }

  .is-tmp .video-js.vjs-skin-control-bar.skin-i2 .vjs-control-bar {
    z-index: 999999999999999999;
  }


  .active-muted {
    position: absolute;
    z-index: 9;
    background-color: #56535366;
    border-radius: 7px;
    color: white;
    padding: 5px 15px;
    margin: 5px;
    font-size: 14px;
    cursor: pointer;
    left: 40px;
  }


  /*fin loader*/
</style>



// WEBPACK FOOTER //
// src/components/UepPlayerComponent.vue